module.exports = __webpack_public_path__ + "img/coding.856965ca.gif";